/**
 * 인사 활동 관리 타입 정의
 * 직원 히스토리 + 근무일정 히스토리 통합 관리
 */

export enum HistoryType {
  EMPLOYEE = 'employee',
  WORK_SCHEDULE = 'work_schedule'
}

export enum EmployeeChangeType {
  HIRED = 'hired',
  TERMINATED = 'terminated',
  UPDATED = 'updated'
}

export enum ScheduleActionType {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted'
}

/**
 * 통합 히스토리 데이터 (직원 + 근무일정)
 */
export interface UnifiedEmployeeHistoryData {
  id: string;
  type: HistoryType;
  employeeName: string;
  action: string;
  timestamp: number;
  description?: string;
  metadata?: Record<string, any>;
  
  // 직원 히스토리 전용 필드
  employeeId?: string;
  changeType?: EmployeeChangeType;
  
  // 근무일정 히스토리 전용 필드
  scheduleId?: string;
  workDate?: string;
  startTime?: string;
  endTime?: string;
  breakTime?: string;
}

/**
 * 직원 히스토리 데이터
 */
export interface EmployeeHistoryData {
  id: string;
  employeeId: string;
  employeeName: string;
  action: string;
  changeType: EmployeeChangeType;
  timestamp: number;
  description?: string;
  metadata?: {
    previousData?: any;
    newData?: any;
    accountNumber?: number;
    [key: string]: any;
  };
}

/**
 * 근무일정 히스토리 데이터
 */
export interface WorkScheduleHistoryData {
  id: string;
  scheduleId: string;
  employeeId: string;
  employeeName: string;
  action: string;
  actionType: ScheduleActionType;
  workDate: string;
  startTime?: string;
  endTime?: string;
  breakTime?: string;
  timestamp: number;
  description?: string;
  metadata?: {
    previousData?: any;
    newData?: any;
    accountNumber?: number;
    [key: string]: any;
  };
}

/**
 * 인사 히스토리 필터 옵션
 */
export interface EmployeeHistoryFilterOptions {
  historyType?: HistoryType;
  employeeIds?: string[];
  changeTypes?: EmployeeChangeType[];
  actionTypes?: ScheduleActionType[];
  dateRange?: {
    start: Date;
    end: Date;
  };
  accountNumber?: number;
}

/**
 * 인사 히스토리 통계
 */
export interface EmployeeHistoryStats {
  totalCount: number;
  employeeHistoryCount: number;
  workScheduleHistoryCount: number;
  employeeCounts: Record<string, number>;
  actionTypeCounts: Record<string, number>;
  recentActivities: UnifiedEmployeeHistoryData[];
}

/**
 * 페이지네이션 상태
 */
export interface EmployeeHistoryPaginationState {
  hasMore: boolean;
  isLoading: boolean;
  lastEmployeeDoc: any | null;
  lastWorkScheduleDoc: any | null;
  error: Error | null;
}

